import { render, staticRenderFns } from "./forgetpwd.vue?vue&type=template&id=d829bac4&scoped=true"
import script from "./forgetpwd.vue?vue&type=script&lang=js"
export * from "./forgetpwd.vue?vue&type=script&lang=js"
import style0 from "./forgetpwd.vue?vue&type=style&index=0&id=d829bac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d829bac4",
  null
  
)

export default component.exports